import ModalReserve, { ReserveBibliography } from './ModalReserve.vue'

export { ModalReserve, ReserveBibliography }
